import { DiscountRestriction } from '@vista-digital/ocapi-types/v1';
import { configurationSettings } from '../../../configuration/configuration-settings';
import { isEmptyArray } from '../../../utils/array-utils';
import { getOrderItemCountByRewardId } from '../../order/selectors/items/get-order-item-count-by-reward-id';
import { getOrderItems } from '../../order/selectors/items/get-order-items';
import { getDiscountById } from '../../sales-data/selectors/discounts/get-discount-by-id';
import { getRewardById } from '../selectors/master-data/rewards/get-reward-by-id';
import { getMemberRewards } from '../selectors/member/rewards/get-member-rewards';
export const getMaximumAllowedMemberRewards = (rewardIds) => {
    const memberRewards = getMemberRewards();
    const filteredRewards = memberRewards === null || memberRewards === void 0 ? void 0 : memberRewards.filter(reward => rewardIds.includes(reward.rewardId));
    if (!filteredRewards || isEmptyArray(filteredRewards))
        return 0;
    const availableRewardCount = filteredRewards.reduce((acc, memberReward) => {
        const { rewardId, availableQuantity } = memberReward;
        const reward = getRewardById(rewardId);
        if (!reward)
            throw new Error(`Cannot find reward with ID '${rewardId}'.`);
        const { balanceCost, limitPerOrder } = reward;
        if (balanceCost)
            return acc; // we don't currently support rewards with a balance cost.
        if (availableQuantity.isUnlimited) {
            const limit = limitPerOrder
                ? Math.min(configurationSettings.data.order.maximumItemsPerOrder, limitPerOrder)
                : configurationSettings.data.order.maximumItemsPerOrder;
            return acc + limit;
        }
        return acc + (limitPerOrder || availableQuantity.value);
    }, 0);
    return availableRewardCount;
};
export const getAvailableMemberRewardCount = (rewardId) => {
    const rewardDiscountItemCount = getDiscountOrderItemCountByRewardId(rewardId);
    const rewardItemCount = getOrderItemCountByRewardId(rewardId);
    const allowedMaximum = Math.min(getMaximumAllowedMemberRewards([rewardId]), configurationSettings.data.order.maximumItemsPerOrder);
    if (!allowedMaximum)
        return allowedMaximum;
    return allowedMaximum - rewardDiscountItemCount - rewardItemCount;
};
const getDiscountOrderItemCountByRewardId = (rewardId) => {
    const rewardDiscountedItems = getOrderItems().filter(item => {
        if (!item.discountId)
            return false;
        const discount = getDiscountById(item.discountId);
        return (discount === null || discount === void 0 ? void 0 : discount.restriction) === DiscountRestriction.MemberReward && discount.rewardIds.includes(rewardId);
    });
    return rewardDiscountedItems.length;
};
